<template>
    <svg :width="width" :height="height" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.03125 9.5V13.8146L10.1562 15.9917V9.5V8.90625L10.542 8.46094L15.625 2.57292V1.58333H1.5625V2.57292L6.64551 8.46094L7.03125 8.90625V9.5ZM5.46875 9.5L0 3.16667V1.58333V0H1.5625H15.625H17.1875V1.58333V3.16667L11.7188 9.5V17.0802V19L10.1562 17.9115L5.46875 14.6458V9.5ZM18.75 0.791667H19.5312H24.2188H25V2.375H24.2188H19.5312H18.75V0.791667ZM16.4062 8.70833H24.2188H25V10.2917H24.2188H16.4062H15.625V8.70833H16.4062ZM16.4062 16.625H24.2188H25V18.2083H24.2188H16.4062H15.625V16.625H16.4062Z" :fill="fill"/>
    </svg>

</template>
<script>
    export default {
        name: 'ui-funnil',
        props: {
            design: {
                type: String,
                default: ''
            },
            fill: {
                type: String,
                default: '#FFF'
            },
            width: {
                type: [String, Number],
                default: 25
            },
            height: {
                type: [String, Number],
                default: 19
            }
        }
    }
</script>